import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_AssessmentV2 = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NBT_AssessmentV2' className='file-pdf-document'>
            <div className='file-template'>



                <p>
                    <span className='eleHeader'>Presenting Problems:</span>
                    <span className='small'>(Brief statement of current mental health symptoms; conduct; behaviors and concerns)</span>
                    <textarea id="txtPresentingProblems_1" name="txtPresentingProblems_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Describe client&#39;s personality as per informant
                    </span>
                    <span className='small'>(Management of anger, problem solving/coping skills, impulsivity, peer relationships and self-esteem, History of temper tantrums/rapid mood swings)
                    </span>
                    <textarea id="txtDescribePersonalityInformant_1" name="txtDescribePersonalityInformant_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Any use of Addictive Substances and Tobacco since previous assessment
                    </span>
                    <span className='small'>(If so, list the name of the substance, age of 1st use, frequency/amount used, date of last use)

                    </span>
                    <textarea id="txtAnyAddictiveSubstancesTobaccoSincePreviousAssessment_1" name="txtAnyAddictiveSubstancesTobaccoSincePreviousAssessment_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Criminal behavior since previous assessment
                    </span>
                    <span className='small'>(Include any Juvenile Offenses i.e. "Unruly", "Run Away")

                    </span>
                    <textarea id="txtCriminalBehaviorSincePreviousAssessment_1" name="txtCriminalBehaviorSincePreviousAssessment_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Describe involvement with community agencies since previous assessment
                    </span>
                    <span className='small'>(DFCS, DJJ, etc. - list contact person, phone number and time period)


                    </span>
                    <textarea id="txtDescribeInvolvementAssessment_1" name="txtDescribeInvolvementAssessment_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Has the child been involved with or has any Mental Health and/or Psychiatric Interventions since previous assessment?
                    </span>
                    <span className='small'>(List name of provider, contact information and length of treatment)


                    </span>
                    <textarea id="txtHasTheChildBeenInvolvedWithOrHasAny_1" name="txtHasTheChildBeenInvolvedWithOrHasAny_1" className='add-only' ></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><h2>Family History</h2>

                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><h3>History Composition</h3><span className='small'>*Anyone that moves in and out of home*</span>

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>1. Name</span></td>
                        <td className='w-375'><span className='eleHeader'>Relationship</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtHistoryCompositionName_1' name='txtHistoryCompositionName_1' className='add-only' />

                        </td>
                        <td className='w-375'> <input type='text' id='txtHistoryCompositionRelationship_1' name='txtHistoryCompositionRelationship_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>DOB/Age</span></td>
                        <td className='w-500'><span className='eleHeader'>Occupation</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtHistoryCompositionDobAge_1' name='txtHistoryCompositionDobAge_1' className='add-only' />

                        </td>
                        <td className='w-500'><input type='text' id='txtHistoryCompositionOccupation_1' name='txtHistoryCompositionOccupation_1' className='add-only' /></td>
                    </tr>



                    <tr>
                        <td className='w-375'><span className='eleHeader'>2. Name</span></td>
                        <td className='w-375'><span className='eleHeader'>Relationship</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtHistoryCompositionName_2' name='txtHistoryCompositionName_2' className='add-only' />

                        </td>
                        <td className='w-375'> <input type='text' id='txtHistoryCompositionRelationship_2' name='txtHistoryCompositionRelationship_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>DOB/Age</span></td>
                        <td className='w-500'><span className='eleHeader'>Occupation</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtHistoryCompositionDobAge_2' name='txtHistoryCompositionDobAge_2' className='add-only' />

                        </td>
                        <td className='w-500'><input type='text' id='txtHistoryCompositionOccupation_2' name='txtHistoryCompositionOccupation_2' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-375'><span className='eleHeader'>3. Name</span></td>
                        <td className='w-375'><span className='eleHeader'>Relationship</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtHistoryCompositionName_3' name='txtHistoryCompositionName_3' className='add-only' />

                        </td>
                        <td className='w-375'> <input type='text' id='txtHistoryCompositionRelationship_3' name='txtHistoryCompositionRelationship_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>DOB/Age</span></td>
                        <td className='w-500'><span className='eleHeader'>Occupation</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtHistoryCompositionDobAge_3' name='txtHistoryCompositionDobAge_3' className='add-only' /></td>
                        <td className='w-500'><input type='text' id='txtHistoryCompositionOccupation_3' name='txtHistoryCompositionOccupation_3' className='add-only' /></td>
                    </tr>



                    <tr>
                        <td className='w-375'><span className='eleHeader'>4. Name</span></td>
                        <td className='w-375'><span className='eleHeader'>Relationship</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtHistoryCompositionName_4' name='txtHistoryCompositionName_4' className='add-only' /></td>
                        <td className='w-375'> <input type='text' id='txtHistoryCompositionRelationship_4' name='txtHistoryCompositionRelationship_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>DOB/Age</span></td>
                        <td className='w-500'><span className='eleHeader'>Occupation</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtHistoryCompositionDobAge_4' name='txtHistoryCompositionDobAge_4' className='add-only' /></td>
                        <td className='w-500'><input type='text' id='txtHistoryCompositionOccupation_4' name='txtHistoryCompositionOccupation_4' className='add-only' /></td>
                    </tr>

                </table>




                <p>
                    <span className='eleHeader'>Have there been any major family stressors during the past six months?
                    </span>
                    <span className='small'>(Have there been any major family stressors during the past six months?)

                    </span>
                    <textarea id="txtHaveThereBeenMajorStressors_1" name="txtHaveThereBeenMajorStressors_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Any significant family medical and / or psychiatric history since previous assessment
                    </span>
                    <textarea id="txtAnySignificantFamilyMedicalAssessment_1" name="txtAnySignificantFamilyMedicalAssessment_1" className='add-only' ></textarea>
                </p>

                <p>
                    <h2>Medical/Psychological</h2>
                </p>
                <p>
                    <span className='eleHeader'>Significant illnesses, injuries for client since previous assessment</span>
                    <textarea id="txtSignificantIllnessesForClientSinceAssessment_1" name="txtSignificantIllnessesForClientSinceAssessment_1" className='add-only' ></textarea>
                </p>

                <table>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Date of Last Physical</span> </td>
                        <td className='w-500'><span className='eleHeader'>Name of Physician</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateofLastPhysical' name='txtDateofLastPhysical' className='add-only' /></td>
                        <td className='w-500'> <input type='text' id='txtNamePhysician' name='txtNamePhysician' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Date of Last Dental</span> </td>
                        <td className='w-500'><span className='eleHeader'>Name of Dentist</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateLastDental' name='txtDateLastDental' className='add-only' /></td>
                        <td className='w-500'> <input type='text' id='txtNameDentist' name='txtNameDentist' className='add-only' /></td>
                    </tr>
                </table>


                <p>
                    <span className='eleHeader'>Are there any current medical / dental complaints?</span>
                    <textarea id="txtAreThereAnyCurrentMedical_1" name="txtAreThereAnyCurrentMedical_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Are there any current medications / prescribing physician?</span>
                    <textarea id="txtAreAnyCurrentMedicationsPrescribingPhysician_1" name="txtAreAnyCurrentMedicationsPrescribingPhysician_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>List current psychotropic medications prescribed (length / dates of usage / impact)</span>
                    <textarea id="txtListCurrentPsychotropicMedications_1" name="txtListCurrentPsychotropicMedications_1" className='add-only' ></textarea>
                </p>
                <p>
                    <h2>Risk and Trauma Assessment</h2>
                </p>
                <p>
                    <span className='eleHeader'>Suicidal/Homicidal Ideation
                    </span>
                    <span className='small'>(Since previous assessment)
                    </span>

                    <textarea id="txtSincePreviousAssessment_1" name="txtSincePreviousAssessment_1" className='add-only' ></textarea>
                </p>
                <p>

                    <span className='eleHeader'>Self--Injurious Behavior
                    </span>
                    <span className='small'>(Since previous assessment)
                    </span>
                    <textarea id="txtSelfInjuriousBehavior_1" name="txtSelfInjuriousBehavior_1" className='add-only' ></textarea>
                </p>
                <p>

                    <span className='eleHeader'>Severely Aggressive Ideation/Behavior
                    </span>
                    <span className='small'>(Since previous assessment)
                    </span>
                    <textarea id="txtSeverelyAggressiveIdeation_1" name="txtSeverelyAggressiveIdeation_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Feelings of persecution
                    </span>
                    <span className='small'>(Does the client report feeling like people are "plotting against", "planning to harm him" or "out-to-get" him?)
                    </span>
                    <textarea id="txtFeelingsPersecution_1" name="txtFeelingsPersecution_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Delusions / Hallucinations
                    </span>
                    <span className='small'>(Does the client report seeing, smelling or hearing things people, odors or sounds that others don&#39;t?)
                    </span>
                    <textarea id="txtDelusionsHallucinations_1" name="txtDelusionsHallucinations_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Obsessive/Compulsive Behaviors
                    </span>
                    <span className='small'>(Does the client experience uncontrollable, unwanted thoughts and repetitive, ritualized behaviors they feel compelled to perform?)
                    </span>
                    <textarea id="txtObsessiveCompulsiveBehaviors_1" name="txtObsessiveCompulsiveBehaviors_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Post-traumatic stress disorder
                    </span>
                    <span className='small'>(Has the client seen or experienced a traumatic event that involved the threat of injury or death?)
                    </span>
                    <textarea id="txtPostTraumaticStressDisorder_1" name="txtPostTraumaticStressDisorder_1" className='add-only' ></textarea>
                    {/* <textarea id="txtPost-TraumaticStressDisorder_1" name="txtPost-TraumaticStressDisorder_1" className='add-only' ></textarea> */}
                </p>
                <p>
                    <span className='eleHeader'>Dissociations
                    </span>
                    <span className='small'>(Does the client have thoughts or emotions seemingly coming out of nowhere, or carrying out an action as if it were controlled by a force outside of self?)
                    </span>
                    <textarea id="txtDissociations_1" name="txtDissociations_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Any changes in sleep pattern since previous assessment?
                    </span>
                    <textarea id="txtAnyChangesInSleepPatternSincePreviousAssessment_1" name="txtAnyChangesInSleepPatternSincePreviousAssessment_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Any changes in eating habits since previous assessment?
                    </span>
                    <textarea id="txtAnyChangesEatingHabitsSincePreviousAssessment_1" name="txtAnyChangesEatingHabitsSincePreviousAssessment_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Other psychosocial or environmental problems
                    </span>
                    <textarea id="txtOtherPsychosocialEnvironmentalProblems_1" name="txtOtherPsychosocialEnvironmentalProblems_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>School History
                    </span>
                    <span className='small'>What school does the child attend? What grade? Has the child changed schools since previous assessment? Has the child received additional school services since previous assessment?
                    </span>
                    <textarea id="txtSchoolHistory_1" name="txtSchoolHistory_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Client&#39;s choice and hopes for recovery
                    </span>
                    <span className='small'>(What does the client want to work on in treatment?)
                    </span>
                    <textarea id="txtClientChoiceHopesRecovery_1" name="txtClientChoiceHopesRecovery_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Strengths
                    </span>
                    <textarea id="txtStrengths_1" name="txtStrengths_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Needs
                    </span>
                    <textarea id="txtNeeds_1" name="txtNeeds_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Abilities
                    </span>
                    <textarea id="txtAbilities_1" name="txtAbilities_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Preferences
                    </span>
                    <textarea id="txtPreferences_1" name="txtPreferences_1" className='add-only' ></textarea>
                </p>
                <p>
                    <h2>General Appearance/Functions</h2>
                </p>


                <p>
                    <span className='eleHeader'>Appearance and Behavior
                    </span>
                    <textarea id="txtAppearanceBehavior_1" name="txtAppearanceBehavior_1" className='add-only' ></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Mood and Affect
                    </span>
                    <textarea id="txtMoodAffect_1" name="txtMoodAffect_1" className='add-only' ></textarea>
                </p>




                <table>
                    <tr><td className='w-750'><h2>ICD-10</h2></td>
                    </tr>
                    <tr><td className='w-375'><span className='eleHeader'>AXIS I
                    </span></td>
                        <td className='w-375'><span className='eleHeader'>AXIS II
                        </span></td></tr>
                    <tr><td className='w-375'> <input type='text' id='txtAxis_1' name='txtAxis_1' className='add-only' /></td>
                        <td className='w-375'> <input type='text' id='txtAxis_2' name='txtAxis_2' className='add-only' /></td>
                    </tr>
                    <tr><td className='w-375'><span className='eleHeader'>AXIS III
                    </span></td>
                        <td className='w-375'><span className='eleHeader'>AXIS IV
                        </span></td></tr>
                    <tr><td className='w-375'> <input type='text' id='txtAxis_3' name='txtAxis_3' className='add-only' /></td>
                        <td className='w-375'> <input type='text' id='txtAxis_4' name='txtAxis_4' className='add-only' /></td>
                    </tr>
                    <tr><td className='w-750'><span className='eleHeader'>AXIS V - GAF
                    </span></td>
                    </tr>
                    <tr><td className='w-750'> <input type='text' id='txtAxisGaf_1' name='txtAxisGaf_1' className='add-only' /></td>

                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Recommendations  from  this  evaluation
                    </span>
                    <span className='small'>Services  being  recommended-ind.,  family;  identify  what  resources/interventions  are  needed  to  help  in  successfully  moving  the  client  through  the  process;  interventions  that  NBT  can  offer  and
                        community-based  needs;  identify  whether  IFI  or  Core  Services  and  concluding  statement
                    </span>
                    <textarea id="txtRecommendations_1" name="txtRecommendations_1" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Transitional  Considerations  for  Discharge  Plan</span>
                    <span className='small'>Define  the  indicators  that  will  determine  when  the  client  is  ready  to  began  to  transition  from  recommended  level  of  care</span>

                    <textarea id="txtTransitionalConsiderationsDischargePlan_1" name="txtTransitionalConsiderationsDischargePlan_1" className='add-only' ></textarea>
                </p>
                <p>

                    <span className='eleHeader'>Interpretative Summary</span>
                    <span className='small'>Include an analysis of the client&#39;s symptoms/behaviors; client&#39;s
                        perception of his/her need for services; Diagnostic Impression: Client&#39;s choice and hopes for recovery; SNAP; Transitional
                        Discharge; identify whether IFI or Core Services and concluding statement</span>
                    <textarea id="txtInterpretativeSummary" name="txtInterpretativeSummary" className='add-only' ></textarea>
                </p>


                <table>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='small w-500'> Assessor/Credentials </td>
                        <td className='small w-250'> Date </td>
                    </tr>

                </table>

                {/* 
                <p className='w-750'><h3>Assessment History</h3>
                    <textarea id='txtAssessmentHistory_1' name='txtAssessmentHistory_1' className='add-only' ></textarea>
                </p> */}






            </div>
        </form>
    )
}